import { api } from '../client';
import type { Geofence } from '../types';

interface ListParams {
  all?: boolean;
  userId?: number;
  deviceId?: number;
  groupId?: number;
  refresh?: boolean;
}

/**
 * Endpoint não documentado no OpenAPI Trackmax 4.10, mas existente no Traccar 4.x.
 * Validar contra https://www.traccar.org/api-reference/#tag/Geofences
 */
export const geofencesApi = {
  list: (params?: ListParams) => api.get<Geofence[]>('/geofences', { query: params }),
  create: (g: Partial<Geofence>) => api.post<Geofence>('/geofences', { body: g }),
  update: (id: number, g: Geofence) => api.put<Geofence>(`/geofences/${id}`, { body: g }),
  delete: (id: number) => api.delete<void>(`/geofences/${id}`),
};
